module.exports = __webpack_public_path__ + "img/service-8-1.4654fa1a.jpeg";